module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABHNCSVQICAgIfAhkiAAAAJ9JREFUWIXt2DEOxCAMRNG/m4txNB8tNyMNVZYtgLFJJI/kxkLidbYML44BtZVtlbTUW9lWDb8gF9Qx8PYDlFuvtP6p4YyBTgJQIyAIQI2CwBk1AwJH1CwInFArIHBArYJAjFKAQIhSgUCEUoJAgFKDYBHlAYKgMTMTo78l/M3X39RN2fGpEbRDJSYxiUlMYhLzRgxPw/RAWzHwwINVSC7yv4bocWmmlAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(4).png
// module id = VBUQ
// module chunks = 1